export default "__VITE_ASSET__BIkxUqHj__"